import EkgRecordingDetails from './EkgRecordingDetails';

export default EkgRecordingDetails;



// WEBPACK FOOTER //
// ./src/views/pages/EkgRecordingDetails/index.js